The set of questions presented to candidates during an application.

The questionnaire responses will be available as CandidateProfile.seekQuestionnaireSubmission on the candidate's application profile.
